import React from "react";

const FeatureIntroComponent = ({ featureIntro }) => {
    return (
        <div>
            {
                featureIntro.map((feature) =>
                (<div className="d-flex justify-content-center">
                    <div className="d-flex justify-content-center text-center flex-column my-5 mt-3 fic ">
                        <div className="section-name font-weight-600 font-sm pb-3">
                            {feature.section}
                        </div>
                        <div className="section-title font-weight-600 col-xs-12 col-lg-4 pb-4">
                            {feature.title}
                        </div>
                        <div className="section-description font-weight-400 col-xs-12 col-lg-8">
                            {feature.description}
                        </div>
                    </div>
                </div>)
                )
            }

            <style jsx>
                {
                    `
                .section-name{
                    text-transform: uppercase;
                    line-height: 19.2px;
                }
                .section-title{
                    font-size: 36px;
                    margin: auto;
                    line-height: 42px;
                }
                .section-description{
                    font-size: 20px;
                    color:#475467;
                    margin: auto;
                }
                 @media screen and (max-width: 1000px) {
                   
                    .fic{
                        max-width:500px;
                    }
                  }
                @media screen and (max-width: 576px) {
                    .section-title{
                     font-size: 29px;
                    }
                    .fic{
                        max-width:310px;
                    }
                  }
                @media screen and (max-width: 400px) {
                    .section-title{
                     font-size: 29.8px;
                      line-height: 44px;        
                        margin-bottom: 20px;        
                        letter-spacing: -0.02em;  
                    }
                    .fic{
                        max-width:310px;
                    }
                  }
                `
                }
            </style>
        </div>
    )
}

export default FeatureIntroComponent;